<template>
  <div class="m-b-32" v-bind="$attrs">
    <WdsHeading :type="titleType">{{ title }}</WdsHeading>
    <WdsText large secondary>{{ subTitle }}</WdsText>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { WdsHeading, WdsText } from '@worksome/wds-components'

defineProps({
  title: {
    type: String,
    default: '',
  },
  titleType: {
    type: String,
    default: 'title3',
    validator(value) {
      return ['display', 'subtitle', 'title1', 'title2', 'title3', 'title4'].includes(value)
    },
  },
  subTitle: {
    type: String,
    default: '',
  },
})
</script>
